import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../UI';

interface PropTypes {
  onClick: (e: any) => void;
  name: string;
  hideModal: () => void;
}

const DeleteModal: React.FC<PropTypes> = ({ name, onClick, hideModal }) => {
  const { t } = useTranslation();

  return (
    <div className="p-12 m-auto text-center -mt-20">
      <h2 className="font-bold text-center text-lg">
        {t('chatroom.deleteModalTitle', {
          name,
        })}
      </h2>
      <p className="text-grey-50 pt-4">{t('chatroom.deleteModalDesc')}</p>
      <div className="flex justify-center pt-8 gap-8">
        <Button type="button" variant="primary" onClick={onClick}>
          {t('chatroom.deleteModalBtn')}
        </Button>
        <Button type="button" variant="primary" onClick={hideModal}>
          {t('chatroom.deleteModalCancelBtn')}
        </Button>
      </div>
    </div>
  );
};

export default DeleteModal;
